
import React from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";

interface EmptyStateProps {
  hideButton?: boolean;
  customTitle?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ hideButton, customTitle }) => {
  return (
    <div className="text-center py-12">
      <div className="mb-6">
        <div className="inline-block p-6 rounded-full bg-primary/10 mb-4">
          <div className="text-4xl">💡</div>
        </div>
        <h3 className="text-lg font-medium mb-2">
          {customTitle ?? "Your Brain is empty right now"}
        </h3>
        {!hideButton && (
          <p className="text-muted-foreground mb-6">
            Start adding your first idea or knowledge entry
          </p>
        )}
      </div>
      {!hideButton && (
        <Link to="/dashboard/new-entry">
          <Button size="lg">
            <Plus className="mr-2 h-4 w-4" />
            Create First Entry
          </Button>
        </Link>
      )}
    </div>
  );
};
